import "core-js/modules/es6.function.name";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getCouponsUser } from "@api/user";
var NAME = "UserCoupon";
export default {
  name: "UserCoupon",
  components: {},
  props: {},
  data: function data() {
    return {
      couponsList: [],
      loading: false
    };
  },
  watch: {
    $route: function $route(n) {
      var that = this;

      if (n.name === NAME) {
        that.getUseCoupons();
      }
    }
  },
  mounted: function mounted() {
    this.getUseCoupons();
  },
  methods: {
    getUseCoupons: function getUseCoupons() {
      var that = this,
          type = 0;
      getCouponsUser(type).then(function (res) {
        that.couponsList = res.data;
        that.loading = true;
      });
    }
  }
};